import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
  id: string;
  username: string;
  fullname: string;
  email: string;
  roles: string[];
  is_active: boolean;
  department?: string;
  sync_account?: number;
  /** 1 = thuộc module tư vấn nhà thầu (đơn vị cấp 1), không cho vào QLVB gốc */
  tuvan_nhathau?: number;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
}

const initialState: AuthState = {
  user: null,
  isAuthenticated: false
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    }
  }
});

export const { setUser, logout } = authSlice.actions;

export default authSlice.reducer;

export type RootState = {
  auth: AuthState;
}; 